import { Button, SxProps } from '@mui/material';
import React, { ReactNode } from 'react';

interface PrimaryButtonProps {
  children: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  fullWidth?: boolean;
  height?: string | undefined
  borderRadius?: string;
  sx?: SxProps;
  customVariant?: 'rounded' | 'rounded-skinny';
}

const PrimaryButton = ({
  type,
  onClick,
  disabled,
  children,
  fullWidth,
  height,
  borderRadius,
  sx,
  customVariant
}: PrimaryButtonProps) => {
  // if a borderRadius is passed in, then it takes priority, else check if a customVariant is specified or default.
  const borderRadiusOverride = borderRadius ? borderRadius : customVariant ? '9999px' : '0.8rem';
  // if a height is passed in, then it takes priority, else check if a customVariant is specified or default.
  const heightOverride = height ? height : customVariant === 'rounded-skinny' ? '2.4rem' : '5rem';
  const minWidthOverride = customVariant === 'rounded-skinny' ? { xs: '105px', md: '136px' } : 'unset';
  const maxWidthOverride = customVariant === 'rounded-skinny' ? '136px' : 'unset';
  return (
    <Button
      disabled={disabled}
      color="secondary"
      variant="contained"
      type={type}
      onClick={onClick}
      sx={[
        {
          width: fullWidth ? { xs: '100%' } : { md: '26rem', xs: '100%' },
          minWidth: minWidthOverride,
          maxWidth: maxWidthOverride,
          height: heightOverride,
          borderRadius: borderRadiusOverride,
          fontSize: '1.5rem',
          fontWeight: 500,
          boxShadow: 'none',
          '&.Mui-disabled': {
            color: "white"
          },
          ':hover': {
            boxShadow: 'none',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
